import { useState } from 'react';

import { createMagicLink, googleSignIn } from '@/services/auth-service.ts';
import { showErrorNotification } from '@/services/notification-service.ts';

export enum LoginStatus {
    INITIAL = 'initial',
    EXTERNAL_FORM = 'external-form',
    SUBMITTING = 'submitting',
    SUCCESS = 'success',
    FAILURE = 'failure',
}

interface UseLoginReturn {
    status: LoginStatus;
    showExternalForm: () => void;
    submitMagicLink: (email: string) => Promise<void>;
    triggerGoogleSignIn: () => Promise<void>;
}

const triggerGoogleSignIn = async (): Promise<void> => {
    try {
        await googleSignIn();
    } catch {
        showErrorNotification('Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
    }
};

export const useLogin = (): UseLoginReturn => {
    const [status, setStatus] = useState<LoginStatus>(LoginStatus.INITIAL);

    const showExternalForm = (): void => {
        setStatus(LoginStatus.EXTERNAL_FORM);
    };

    const submitMagicLink = async (email: string): Promise<void> => {
        setStatus(LoginStatus.SUBMITTING);
        try {
            await createMagicLink(email);
            setStatus(LoginStatus.SUCCESS);
        } catch {
            setStatus(LoginStatus.FAILURE);
            showErrorNotification('Login-Link konnte nicht erstellt werden. Bitte versuchen Sie es erneut.');
        }
    };

    return {
        status,
        showExternalForm,
        submitMagicLink,
        triggerGoogleSignIn,
    };
};
